<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="rep1">
        <input type="checkbox" class="custom-control-input mgntp10" id="rep1" value="Once a month" name="rep"
          [(ngModel)]="hgReplace.option1" (click)="getReplace($event)" />
        <label class="custom-control-label font20" for="rep1">Once a month</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="rep2">
        <input type="checkbox" class="custom-control-input mgntp10" id="rep2" value="Every 2 to 3 months" name="rep"
          [(ngModel)]="hgReplace.option2" (click)="getReplace($event)" />
        <label class="custom-control-label font20" for="rep2">Every 2 to 3 months</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="rep3">
        <input type="checkbox" class="custom-control-input mgntp10" id="rep3" value="Every 4 to 6 months" name="rep"
          [(ngModel)]="hgReplace.option3" (click)="getReplace($event)" />
        <label class="custom-control-label font20" for="rep3">Every 4 to 6 months</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="rep4">
        <input type="checkbox" class="custom-control-input mgntp10" id="rep4" value="Once a year" name="rep"
          [(ngModel)]="hgReplace.option4" (click)="getReplace($event)" />
        <label class="custom-control-label font20" for="rep4">Once a year</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="rep5">
        <input type="checkbox" class="custom-control-input mgntp10" id="rep5" value="I/m supposed to replace a filter!?"
          name="rep" [(ngModel)]="hgReplace.option5" (click)="getReplace($event)" />
        <label class="custom-control-label font20" for="rep5"><span *ngIf="questionFlowType && questionFlowType == 'renewal'">Oops!</span>I'm supposed to replace a filter!?</label>
      </label>
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
    <!-- <p class="text-success mt-3" *ngIf="showTip">{{questionObj.tip}}</p> -->

    <div>
      <div class="mt-5">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
          <img src="assets/images/flash.png" class="mb-1" />
          <p class="text-center tiphead">FUN FACT</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">FUN FACT<br>
          <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box" >
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <label class="custom-control custom-checkbox chkbox mb-2" for="rep1_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="rep1_mob" value="Once a month" name="rep"
        [(ngModel)]="hgReplace.option1" (click)="getReplace($event)" />
      <label class="custom-control-label font20" for="rep1_mob">Once a month</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="rep2_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="rep2_mob" value="Every 2 to 3 months" name="rep"
        [(ngModel)]="hgReplace.option2" (click)="getReplace($event)" />
      <label class="custom-control-label font20" for="rep2_mob">Every 2 to 3 months</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="rep3_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="rep3_mob" value="Every 4 to 6 months" name="rep"
        [(ngModel)]="hgReplace.option3" (click)="getReplace($event)" />
      <label class="custom-control-label font20" for="rep3_mob">Every 4 to 6 months</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="rep4_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="rep4_mob" value="Once a year" name="rep"
        [(ngModel)]="hgReplace.option4" (click)="getReplace($event)" />
      <label class="custom-control-label font20" for="rep4_mob">Once a year</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="rep5_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="rep5_mob" value="I/m supposed to replace a filter!?"
        name="rep" [(ngModel)]="hgReplace.option5" (click)="getReplace($event)" />
      <label class="custom-control-label font20" for="rep5_mob"><span *ngIf="questionFlowType && questionFlowType == 'renewal'">Oops!</span>I'm supposed to replace a filter!?</label>
    </label>
    <p class="m-auto mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <div style="width:97% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right mb-2" >
        <h1 class="ansMob text-right">{{replace_acfilter}}</h1>
      </div>
    </div>
    <br />
    <div *ngIf="showTip">
      <div>
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
          <img src="assets/images/flash.png" class="mb-1" style="margin-left: 48%" />
          <p class="text-center tiphead">FUN FACT</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">FUN FACT<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
          <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div> -->
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active24.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active17.png"></span>
    <h5 class="clr333 processtxt">85% Completed</h5>
  </div>
</div> -->